import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const localAIConn = 'InstrumentationKey=675d6b72-69af-4139-a44f-88c33ccff8c3;IngestionEndpoint=https://southcentralus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/';
const prodAIConn = 'InstrumentationKey=8221cd99-926d-45b4-93f8-2dde6ef62987;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/';//'InstrumentationKey=913955d9-53d5-4076-9343-6aae217776fd;IngestionEndpoint=https://westus2-1.in.applicationinsights.azure.com/';

const conn = process.env.NODE_ENV === 'development' ? localAIConn : prodAIConn;

const appInsights = new ApplicationInsights({
    config: {
        connectionString: conn,
        enableAutoRouteTracking: true
    }
});

appInsights.loadAppInsights();
appInsights.trackPageView();

export const aiFileDownloaded = (file, matrix) => {
    appInsights.trackEvent({
        name: 'fileDownloaded',
        properties: {
            file, matrix
        }
    })
}

export default appInsights;
